import { useLabOrderDetailsStore } from '../../../../stores';
import AlbumOrderSummaryCard from './AlbumOrderSummaryCard';
import styles from './AlbumOrderSummary.module.css';

const AlbumOrderSummary = ({ showAlbumActions = false, albumOrderDetailsProp, onDeleteAlbum }) => {
  const albumOrderDetails = albumOrderDetailsProp ?? useLabOrderDetailsStore((s) => s.albumOrderDetails);
  if (!albumOrderDetails?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>Album Orders</h2>
      {albumOrderDetails.map((detail) => (
        <AlbumOrderSummaryCard
          key={detail?.id ?? detail?.attributes?.guid}
          resource={detail}
          showActions={showAlbumActions}
          onDeleteAlbum={onDeleteAlbum}
        />
      ))}
    </div>
  );
};

export default AlbumOrderSummary;
